// PCFs commonly declare max_particles=1000 even for single-particle flashes.
// Reserve the bounded population the emitters can sustain, not every unused
// slot in each child system; leave room for concurrent players and projectiles.
export function particleCapacity(definition, spec = {}) {
    const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
    const maximum = Math.min(1024, Math.max(1, number(definition.max_particles, 1000)));
    let lifetime = 1;
    for (const op of definition.initializers) {
        const name = op.name.toLowerCase().replaceAll('_', ' ');
        if (name === 'lifetime random') lifetime = Math.max(.01, number(op.lifetime_max, 1));
        if (name === 'lifetime from control point life time') lifetime = spec.flame?.life ?? 1;
        if (name === 'lifetime from sequence') lifetime = Math.max(lifetime, 2);
        if (name === 'move particles between 2 control points' || name === 'remap initial scalar' && Number(op['output field']) === 1) return maximum;
    }
    let population = Math.max(0, number(definition.initial_particles));
    for (const op of definition.emitters) {
        const name = op.name.toLowerCase();
        if (name === 'emit_instantaneously') population += Math.max(0, number(op.num_to_emit, 100));
        else if (name === 'emit_continuously' || name === 'emit noise') {
            const rate = Math.max(0, number(name === 'emit noise' ? op['emission maximum'] : op.emission_rate, 100));
            const duration = number(op.emission_duration);
            population += rate * Math.min(lifetime, duration > 0 ? duration : lifetime);
        } else return maximum;
    }
    return Math.min(maximum, Math.max(1, Math.ceil(population * 1.25) + (population ? 4 : 0)));
}
